import { render, staticRenderFns } from "./InsurancePerson.vue?vue&type=template&id=73a2414a&scoped=true"
import script from "./InsurancePerson.vue?vue&type=script&lang=js"
export * from "./InsurancePerson.vue?vue&type=script&lang=js"
import style0 from "./InsurancePerson.vue?vue&type=style&index=0&id=73a2414a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2414a",
  null
  
)

export default component.exports